module.exports = __webpack_public_path__ + "static/why-content-image-9-907cab328293faed6c4a2e21436da038.svg";